<template>
  <section class="ai-visibility-citation-question-usage-list">
    <div class="ai-visibility-citation-question-usage-list__heading">
      <h3>Questions where AI used this page</h3>
      <p>{{ totalCitationCount }} total citations across these questions</p>
    </div>

    <div v-if="questions.length" class="ai-visibility-citation-question-usage-list__list">
      <div
        v-for="question in questions"
        :key="question.questionId"
        class="ai-visibility-citation-question-usage-list__row"
      >
        <span class="ai-visibility-citation-question-usage-list__question">
          {{ question.questionText }}
        </span>
        <span class="ai-visibility-citation-question-usage-list__count">
          Cited: <strong>{{ question.citationCount }}</strong>
        </span>
        <status-pill
            style="min-width: 95px"
          :tone="question.trackedBrandMentioned ? 'success' : 'danger'"
          :label="getStatusLabel(question)"
          dot
        />
      </div>
    </div>
    <p v-else class="ai-visibility-citation-question-usage-list__empty">
      {{ emptyMessage }}
    </p>

    <div class="ai-visibility-citation-question-usage-list__actions">
      <button
        type="button"
        class="ai-visibility-citation-question-usage-list__primary"
        @click="viewPrompts"
      >
        View in Prompts
      </button>
    </div>
  </section>
</template>

<script>
import StatusPill from '../../../ui/display/StatusPill.vue'

export default {
  name: 'CitationQuestionUsageList',
  components: {
    StatusPill,
  },
  props: {
    questions: {
      type: Array,
      default() {
        return []
      },
    },
  },
  computed: {
    totalCitationCount() {
      return this.questions.reduce((total, question) => {
        return total + Number(question.citationCount || 0)
      }, 0)
    },
    questionIds() {
      return this.questions
        .map(question => question.questionId)
    },
    emptyMessage() {
      return 'No prompt details are available for this cited page yet.'
    },
  },
  methods: {
    viewPrompts() {
      this.$emit('view-prompts', {
        questionIds: this.questionIds,
      })
    },
    getStatusLabel(question) {
      return question.trackedBrandMentioned ? "You're in" : "You're out"
    },
  },
}
</script>

<style lang="scss" scoped>

.ai-visibility-citation-question-usage-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.ai-visibility-citation-question-usage-list__heading {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.ai-visibility-citation-question-usage-list__heading h3,
.ai-visibility-citation-question-usage-list__heading p,
.ai-visibility-citation-question-usage-list__empty {
  margin: 0;
}

.ai-visibility-citation-question-usage-list__heading h3 {
  color: var(--v-mainColor-base);
  font-size: 16px;
  font-weight: 700;
}

.ai-visibility-citation-question-usage-list__heading p,
.ai-visibility-citation-question-usage-list__empty {
  color: #363636;
  font-size: 16px;
  line-height: 1.5;
}

.ai-visibility-citation-question-usage-list__list {
  overflow: hidden;
  border: 1px solid var(--v-gray13Color-base);
  border-radius: 12px;
  background: var(--v-cardBg-base);
  padding: 5px 0;
}

.ai-visibility-citation-question-usage-list__row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto auto;
  align-items: center;
  gap: 24px;
  border-bottom: 1px dashed var(--v-gray12Color-base);
  padding: 10px 20px;
}

.ai-visibility-citation-question-usage-list__row:last-child {
  border-bottom: 0;
}

.ai-visibility-citation-question-usage-list__question {
  min-width: 0;
  color: var(--v-mainColor-base);
  font-size: 16px;
  line-height: 1.5;
  overflow-wrap: anywhere;
}

.ai-visibility-citation-question-usage-list__count {
  color: #363636;
  font-size: 16px;
  line-height: 1.5;
  white-space: nowrap;
}

.ai-visibility-citation-question-usage-list__count strong {
  color: var(--v-mainColor-base);
  font-weight: 700;
}

.ai-visibility-citation-question-usage-list__actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 20px;
}

.ai-visibility-citation-question-usage-list__primary {
  display: inline-flex;
  min-height: 36px;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 700;
  padding: 8px 20px;
  white-space: nowrap;
}

.ai-visibility-citation-question-usage-list__primary {
  border: 1px solid var(--v-mainColor-base);
  background: var(--v-cardBg-base);
  color: var(--v-mainColor-base);
}

.ai-visibility-citation-question-usage-list__primary:focus {
  outline: 2px solid var(--v-lightYellowColor-base);
  outline-offset: 2px;
}

@media (max-width: 620px) {
  .ai-visibility-citation-question-usage-list__row {
    grid-template-columns: minmax(0, 1fr);
    gap: 8px;
  }

  .ai-visibility-citation-question-usage-list__actions {
    justify-content: stretch;
  }

  .ai-visibility-citation-question-usage-list__primary {
    flex: 1 1 100%;
  }
}
</style>
